import ITask from '../../../Utility/Task/ITask';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import FarmSystem from '../FarmSystem';
import { PlayerTask } from 'State/Player/PlayerTasks';
import FarmTaskHelper from './FarmTaskHelper';

export default class FarmSyncTask implements ITask<FarmSystem> {
    public *execute(system: FarmSystem): IterableIterator<number> {
        const state = system.store.getState().playerState;
        if (state.tasks.length > 0) {
            for (const taskData of state.tasks) {
                switch (taskData.task) {
                    case PlayerTask.FARM_FTUX:
                        FarmTaskHelper.FarmFTUX(system, taskData);
                        break;
                    case PlayerTask.FARM_PET_FTUX:
                        FarmTaskHelper.FarmPetFTUX(system, taskData);
                        break;
                }
            }
            PlayerActions.clearTasks();
        }
    }
}
